import Page from "components/Page";
import { Props } from "./WorkflowConfigurations";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const WorkflowConfigurations = lazyWithRetry(() =>
  import("./WorkflowConfigurations")
);

export default (props: Props) => (
  <Page>
    <WorkflowConfigurations {...props} />
  </Page>
);
